// extracted by mini-css-extract-plugin
module.exports = {"margin":"style__margin__tTfXs"};